import * as THREE from 'three'
import Experience from '../Experience.js'

export default class Floor {
    parameters = {
        width: 1,
        height: 0.5,
        depth: 1,
        offset: 0
    }

    constructor(width, depth, offset) {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        this.parameters.width = width
        this.parameters.depth = depth
        this.parameters.offset = offset

        this.setGeometry()
        this.setMaterial()
        this.setMesh()
    }

    setGeometry()
    {
        this.geometry = new THREE.BoxGeometry(this.parameters.width + this.parameters.offset, this.parameters.height, this.parameters.depth + this.parameters.offset)
    }

    setMaterial()
    {
        this.material = new THREE.MeshStandardMaterial({})

        // Classic material color for now
        this.material.color = new THREE.Color('#C8CABE')
    }

    setMesh()
    {
        this.mesh = new THREE.Mesh(this.geometry, this.material)
        this.mesh.position.set(this.parameters.width / 2 , - 0.75 , this.parameters.depth / 2 )
        this.scene.add(this.mesh)
    }
}